import React from 'react';
import Modal from '../../components/Modal';
//<88181> 
const Formulario = props => (
  <Modal title={props.title} idModal='mantenimiento' isOpen={props.isOpen} closeModal={props.closeModal} 
  modalSize='modal-dialog modal-lg'>
    <div className='form-group'>
      <div className='row'>
	  
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='familia'>Familia</label>
          <div className='select'>
            <select className='form-control' id='familia' onChange={props.onChangeValue} name='familiaFormulario'
			value={props.familiaFormulario} disabled={props.disabled}>
              <option disabled value=''>Selecciona una familia</option>
              {
                props.familias.map(familia => (
                  <option
                    key={familia.codFamiliaVeh}
                    value={familia.codFamiliaVeh}
                  >
                    {familia.desFamiliaVeh}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>	

      </div>
    </div>

      <div className='modal-actions'>
      <button className='btn btn-return' onClick={() => props.closeModal()}>Cancelar</button>
      { !props.disabled ?
        <button className='btn btn-primary pull-right' onClick={() => props.create()}>Guardar</button> :
        <button className='btn btn-primary pull-right' onClick={() => props.edit(props.registroSelected)}>Guardar</button>
      }
    </div>

	  <div className='pageHead-rowContainer'>
    <div className='pageHead-tableConf wrapper'>
      <div className='pageHead-tableConf-tabs'>
        <ul className='tabs' role='tablist'>
          <li className={`tabs-item ${'active'}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Equipos</a>          
          </li>
		  <li className={`tabs-item ${null}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Caract Técnicas</a>          
          </li>
		  <li className={`tabs-item ${null}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Específic técnicas</a>          
          </li>
		  <li className={`tabs-item ${null}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Acces aduaneros</a>          
          </li>
		  <li className={`tabs-item ${null}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Imagenes</a>          
          </li>
		  <li className={`tabs-item ${null}`} >
		    <a className='tabs-item-link checkDeGrillaCerrar'>Equip seguridad de serie</a>          
          </li>
        </ul>
      </div>	  
    </div>
  </div>
  
  
  </Modal>
);

Formulario.defaultProps = {
  isOpen: false,
};

export default Formulario;



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/Formulario.js